import type { Resource } from '../../';
export const product_details_addToCart_backorder: Resource = {"default":"Add To Cart - Backorder"};
